<!--
 * @Description: 
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: xie
 * @LastEditTime: 2025-12-10 11:47:53
-->
<template>
  <div>
    <sortNum v-if="status==1"></sortNum>
    <printCode v-if="status==2"></printCode>
    <tableRecord v-if="status==3"></tableRecord>
    <autoPrintNum v-if="status==4"></autoPrintNum>
    <mfrCodeVerify v-if="status==5"></mfrCodeVerify>
    <sampleInOutRegister v-if="status==6"></sampleInOutRegister>
    <el-dialog title="退出提示" :visible.sync="dialogVisible" width="4rem" :show-close="false" center :before-close="handleClose">
      <span>是否继续退出?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import sortNum from './sortNum.vue'
import tableRecord from './tableRecord.vue'
import printCode from './printCode.vue'
import autoPrintNum from './autoPrintNum.vue'
import mfrCodeVerify from './mfrCodeVerify.vue'
import sampleInOutRegister from './sampleInOutRegister.vue'
import { mapActions } from 'vuex'
export default {
  name: 'homePage',
  components: {
    sortNum,
    tableRecord,
    printCode,
    autoPrintNum,
    mfrCodeVerify,
    sampleInOutRegister
  },

  data() {
    return {
      status: 0,
      dialogVisible: false
    }
  },
  created() {
    this.status = localStorage.getItem('status')
  },
  mounted() {

    const _this = this
    window.document.onkeydown = function (e) {
      if (e.key === 'F12' && e.ctrlKey) {
        this.dialogVisible = false
        _this.open()
      }

      if (e.key === 'Enter' && e.ctrlKey) {
        _this.confirm()
      }
    }
  },
  destroyed() {
    window.document.onkeydown = null
  },
  methods: {
    ...mapActions('tenant', ['del_tenantInfo']),
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    confirm() {
      if (this.dialogVisible) {
        this.del_tenantInfo()
        localStorage.clear()
        window.location.reload()
        this.dialogVisible = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep .el-dialog__body {
  text-align: center;
}
</style>